window.TAPAS_ENV =
  name: 'production'
  application: 'board_production'

  apiRoot:         '//app.smartomato.ru'
  themePreviewUrl: '//{id}.smartomato.ru'
  mobileAppPreviewUrl: 'https://flutter.smartomato.ru/?id={id}'
  fayeUrl:         '//smartomato.ru/faye'
  registerUrl:     '//smartomato.ru/#registration'
  organizationIdHost: '{id}.smartomato.ru'
  supportEmail:       'support@smartomato.ru'
  offerUrl:           '//smartomato.ru/offer.pdf'
  orderMachineWebUrl: '//smartomato.ru/m/manager'

  intercomEnabled: true
  intercomAppId:   'hkhct6l0'

  recaptchaSitekey: '6LfSqyATAAAAAJz4zk1BD5IxJz3aX5WYGzQC05kz'

  maxNotifications: 3
  courierPollingInterval: (1000 * 60 * 10)

  orderViewedByInterval: (1000 * 75)

  courierAndroidAppUrl:   'https://play.google.com/store/apps/details?id=ru.smartomato.order_machine'
  courierIOSAppUrl:   'https://apps.apple.com/us/app/order-machine/id1465249934'

  rollbarToken: '65eeb80442e947a7a7db112e43611369'

  sipWSUrl: 'wss://smartomato.ru/sipws'

  features:
    returnedChart:       false
    clientsChart:        false
    timeMachine:         false
    externalTransports:  false
    mapNotifications:    true
    billingWarnings:     true
    tariffChangeEnabled: true
    clientCRM:           true
    orderMap:            true
    orderCreate:         true
    newOrderPopup:       true
    clientCanRate:       false
    reports:             true
    web_analytics:       true
    label_printer:       false
    require_change:      false
    require_cutlery:     false

